import { createSelector } from 'reselect';

import { SelectedCoworkingType } from 'shared/enums/SelectedCoworkingType';
import { offerIdAsNumberSelector } from 'shared/store/custom';

import { getCoworkingFixedWorkplaceSelector } from '../dump/getCoworkingFixedWorkplaceSelector';
import { getCoworkingFlexWorkplaceSelector } from '../dump/getCoworkingFlexWorkplaceSelector';

import { separateOfficeSelector } from './separateOfficeSelector';

export const selectedCoworkingTypeSelector = createSelector(
  [
    separateOfficeSelector,
    getCoworkingFixedWorkplaceSelector,
    getCoworkingFlexWorkplaceSelector,
    offerIdAsNumberSelector,
  ],
  (selectedOffer, fixedWorkplace, flexWorkplace, offerId) => {
    if (typeof offerId !== 'number') {
      return SelectedCoworkingType.None;
    }

    if (flexWorkplace?.id === offerId) {
      return SelectedCoworkingType.FlexibleWorkplace;
    }

    if (fixedWorkplace?.id === offerId) {
      return SelectedCoworkingType.FixedWorkplace;
    }

    if (selectedOffer) {
      return SelectedCoworkingType.SeparateOffice;
    }

    return SelectedCoworkingType.None;
  },
);
